var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[_vm.btnClass, _vm.colorVariants],attrs:{"type":_vm.buttonType,"variant":_vm.variant,"variant-type":_vm.variantType,"size":_vm.size,"href":_vm.to}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }